module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/consultation_conductor/icon_phone-9ec0bf48cf081dfcb3dd5b126aec2575.svg";